"use strict";
if (typeof document !== "undefined") {
    const styleId = "custom-select-styles";
    if (!document.getElementById(styleId)) {
        const styleElement = document.createElement("style");
        styleElement.id = styleId;
        styleElement.innerHTML = `
    /* Container */
    .select-container {
      position: relative;
      display: inline-block;
      width: 100%;
    }
    /* Trigger Button */
    .select-trigger {
      display: flex;
      height: 40px;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      border-radius: 6px;
      border: 1px solid #e2e8f0;
      background-color: #fff;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 1.5;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      transition: all 0.15s ease-in-out;
      cursor: pointer;
      outline: none;
      font-family: inherit;
      text-align: left;
    }
    .select-trigger:hover:not(:disabled) {
      background-color: #f8fafc;
      border-color: #cbd5e1;
    }
    .select-trigger:focus:not(:disabled) {
      border-color: #94a3b8;
      box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.2);
    }
    .select-trigger:disabled {
      cursor: not-allowed;
      opacity: 0.5;
      background-color: #f9fafb;
    }
    .select-trigger-error {
      border-color: #ef4444;
    }
    .select-trigger-error:focus {
      border-color: #ef4444;
      box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
    }
    /* Select Value */
    .select-value {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #1e293b;
    }
    .select-placeholder {
      color: #94a3b8;
    }
    /* Select Icon */
    .select-icon {
      height: 16px;
      width: 16px;
      opacity: 0.5;
      flex-shrink: 0;
      margin-left: 8px;
      transition: transform 0.2s;
    }
    .select-trigger[aria-expanded="true"] .select-icon {
      transform: rotate(180deg);
    }
    .select-icon-error {
      color: #ef4444;
    }
    /* Content Dropdown */
    .select-content {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      z-index: 1050;
      margin-top: 4px;
      overflow: hidden;
      border-radius: 6px;
      border: 1px solid #e2e8f0;
      background-color: #ffffff;
      color: #1e293b;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      animation: select-show 0.15s ease-out;
    }
    @keyframes select-show {
      from {
        opacity: 0;
        transform: translateY(-4px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    /* Viewport */
    .select-viewport {
      padding: 4px;
      max-height: 256px;
      overflow-y: auto;
    }
    /* Select Item */
    .select-item {
      position: relative;
      display: flex;
      width: 100%;
      cursor: pointer;
      user-select: none;
      align-items: center;
      border-radius: 4px;
      padding: 8px 8px 8px 32px;
      font-size: 14px;
      outline: none;
      transition: background-color 0.1s ease;
    }
    .select-item:hover:not(.select-item-disabled) {
      background-color: #f1f5f9;
    }
    .select-item:focus {
      background-color: #f1f5f9;
    }
    .select-item-selected {
      background-color: #f3f4f6;
    }
    .select-item-disabled {
      pointer-events: none;
      opacity: 0.5;
      cursor: not-allowed;
    }
    /* Item Indicator */
    .select-item-indicator {
      position: absolute;
      left: 8px;
      display: flex;
      height: 14px;
      width: 14px;
      align-items: center;
      justify-content: center;
    }
    /* Item Text */
    .select-item-text {
      flex: 1;
    }
    /* Select Group */
    .select-group {
      padding: 2px 0;
    }
    /* Select Label */
    .select-label {
      padding: 8px 8px 6px;
      font-size: 12px;
      font-weight: 600;
      color: #64748b;
    }
    /* Select Separator */
    .select-separator {
      margin: 4px 0;
      height: 1px;
      background-color: #e2e8f0;
    }
    /* Scrollbar styling */
    .select-viewport::-webkit-scrollbar {
      width: 8px;
    }
    .select-viewport::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 4px;
    }
    .select-viewport::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;
    }
    .select-viewport::-webkit-scrollbar-thumb:hover {
      background: #94a3b8;
    }
  `;
        document.head.appendChild(styleElement);
    }
}
